import type { Locale, LocaleCode } from '@whispli/i18n/types'

export const find = (locales, locale?: Locale | LocaleCode | string): Locale | null => {
  if (!locale) {
    return null
  }

  const code = (typeof locale === 'object' ? locale.code : locale)?.toLowerCase()

  return code && locales.find((obj) => obj.code.toLowerCase() === code) || null
}
